var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Blue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "31px",
    viewBox: "0 0 25 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MAP/4Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4Blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4964035,4.28515625 L5.0675433,4.28515625 L2.12431128,21.7456814 L11.6437016,21.5317625 L11.2180022,29.726475 L21.1842672,28.8445046 L21.4981854,21.310469 L23.0849609,21.274406 L23.0849609,14.5684976 L21.7573321,14.6365812 L22.2824592,1.6484375 L12.6611808,1.6484375 L12.4964035,4.28515625 Z",
    id: 4,
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#0CB2C0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#000000",
    points: "12.604126 4.99719238 10.6240234 16.0429687 12.9443359 15.9726562 13.6514282 1.78088379"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Blue);
export default __webpack_public_path__ + "static/media/4Blue.71afcda465f3748f50d3c5b600844a37.svg";
export { ForwardRef as ReactComponent };